import { useBranding } from "@app-setup:BrandingContext";
import { Box, useTheme } from "@mui/material";
import { Waveform } from "@pages:app/audio/components/Waveform";

/*
 * Taken from `conversation_en.wav`.
 */
const SAMPLE_SECONDS = 11.36;
const SAMPLE_PEAKS = [
  0, 0, 0.03, 0.04, 0.04, 0.06, 1, 0.84, 0.36, 0.37, 0.47, 0.19, 0.48, 0.34,
  0.23, 0.05, 0.05, 0.06, 0.08, 0.28, 0.59, 0.41, 0.37, 0.89, 0.44, 0.72, 0.62,
  0.7, 0.52, 0.08, 0.07, 0.04, 0.04, 0.04, 0.28, 0.77, 0.64, 0.88, 0.34, 0.28,
  0.08, 0.05, 0.05, 0.04, 0.14, 0.48, 0.66, 0.35, 0.39, 0.39, 0.15, 0.06, 0.28,
  0.18, 0.45, 0.33, 0.44, 0.55, 0.44, 0.14, 0.12, 0.04, 0.05, 0.11, 0.85, 0.74,
  0.64, 0.69, 0.77, 0.86, 0.36, 0.38, 0.29, 0.59, 0.29, 0.06, 0.04, 0.04, 0.04,
  0.03, 0.21, 0.7, 0.87, 0.49, 0.84, 0.88, 0.75, 0.71, 0.32, 0.63, 0.24, 0.04,
  0.04, 0.03, 0.04, 0.03,
];
const SAMPLE_TURNS: Array<[number, number, number]> = [
  [0.73, 1.73, 1],
  [2.41, 3.49, 2],
  [4.17, 4.77, 2],
  [5.39, 7.12, 1],
  [7.58, 8.9, 1],
  [9.58, 10.68, 2],
];
const SPEECH_FLOOR = 0.22;
const SILENCE_CEILING = 0.08;

const sampleSpeakerAt = (index: number) => {
  const seconds = ((index + 0.5) / SAMPLE_PEAKS.length) * SAMPLE_SECONDS;
  return (
    SAMPLE_TURNS.find(([from, to]) => seconds >= from && seconds <= to)?.[2] ??
    null
  );
};
const samplePeaks = SAMPLE_PEAKS.map((peak, index) =>
  sampleSpeakerAt(index) === null
    ? Math.min(peak, SILENCE_CEILING)
    : Math.max(peak, SPEECH_FLOOR),
);

/*
 * A recording's waveform colored by speaker.
 */
export const SampleWaveform = () => {
  const theme = useTheme();
  const { config } = useBranding();
  const colors = [
    theme.palette.primary.main,
    config?.secondaryColor ?? theme.palette.primary.dark,
  ];
  const barColor = (index: number) => {
    const speaker = sampleSpeakerAt(index);
    return speaker === null ? null : colors[speaker - 1];
  };

  return (
    <Box aria-hidden sx={{ width: "100%", mb: 1 }}>
      <Waveform peaks={samplePeaks} barColor={barColor} reveal />
    </Box>
  );
};
